<template>
  <div
    class="modal fade modal-library show"
    :id="modal"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            Carregar Arquivos
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body pr-0">
          <div class="row">
            <div class="col-md-6 row">
              <div class="col-12 col-md-6 options pt-2 pl-1">
                <p class="col-12 pr-0">Selecione o Arquivo</p>
                <label for="upload-files-modal" class="nav-link text-black">
                  <i class="fa fa-desktop"></i>&nbsp;Computador
                </label>
              </div>

              <div class="col-12 col-md-6 files pt-2 pl-2">
                <p>Carregando</p>
                <item-upload
                  v-for="item,i in uploadingFiles"
                  :key="i"
                  :file="item"
                  @finished="loadLibrary"
                />
              </div>

              <div class="col-12 upload">
                <div
                  class="w-100 text-center upload-area"
                  @drop.prevent="addFileDrop"
                  @dragover.prevent
                >
                  <i class="fa fa-3x fa-upload" @drop.prevent></i>
                  <br @drop.prevent>
                  <p  @drop.prevent>
                    Arraste os arquivos aqui para fazer o upload!
                  </p>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 library pt-2 pl-2">
              <p>Midias na Biblioteca</p>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Buscar..."
                v-model="filter"
                @keyup="loadLibrary()"
              />
              <small>* Com dois cliques você selecionar o arquivo.</small>
              <medias v-if="items.data != undefined" :items="items.data" @selectMedia="selectMedia" @reload="loadLibrary"/>

              <pagination :data="items" :limit="2" size="small" @pagination-change-page="loadLibrary"></pagination>
            </div>
          </div>
        </div>

        <input
          class="collapse"
          type="file"
          id="upload-files-modal"
          name="upload-files"
          ref="filesModal"
          @change="uploadFiles"
          multiple
        >

        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import ItemUpload from './Upload'
import Medias from './Medias'
import { mapGetters } from 'vuex'

export default {
  components: {
    "item-upload": ItemUpload,
    "medias": Medias,
  },
  props: {
    modal: {
      required: true,
    }
  },
  data () {
    return {
      uploadingFiles: [],
      items: {},
      filter: "",
    }
  },
  methods: {
    uploadFiles: function () {
      let files = this.$refs.filesModal.files
      this.uploadingFiles.push(...files)
    },

    addFileDrop(e) {
      let files = e.dataTransfer.files;
      if(!files) return;
      this.uploadingFiles.push(...files)
    },

    loadLibrary: function (page=1) {
      Axios.get(`/teacher/library/${ this.currentUser.id }/items?page=${page}`, {
        params: {
          name: this.filter
        }
      })
        .then( res => {
          this.items = res.data
        })
    },

    selectMedia: function (item) {
      this.$emit('returnMedia', item)
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser"
    })
  },
  mounted () {
    $("#" + this.modal).on('show.bs.modal', () => this.loadLibrary())
  }
}
</script>
